const productController = UD_VUE.createApp({
	data() {
		return {
			top: null,
			bottom: null,
			loading: true,
			sale_enabled: window.sale_enabled,
			buttonActive: false
		};
	},

	computed: {
		productPrice() {
			return (
				console.log(this.selectedVariantTop.price),
				console.log(this.selectedVariantBottom.price),
				this.selectedVariantTop.price + this.selectedVariantBottom.price 
			);
		},

		sitewideDiscount() {

			return this.productPrice 
		},

		productImages() {
			return [
				this.selectedVariantTop.featured_image,
				this.selectedVariantBottom.featured_image,
			];
		},

		selectedTop() {
			return this.top[this.top.selectedLength];
		},

		selectedBottom() {
			if (this.bottom.selectedLength == "long") {
				return this.bottom[this.bottom.selectedLength][
					this.bottom.selectedInseam
				];
			} else {
				return this.bottom[this.bottom.selectedLength];
			}
		},

		selectedVariantTop: function () {
			let variants = this.top[this.top.selectedLength].product.variants;
			let options = [];

			for (const [key, value] of Object.entries(
				this.top[this.top.selectedLength].selectedOptions
			)) {
				options.push(value);
			}

			let variant = variants.find((variant) => {
				let variantOptions = variant.title.split(" / ");
				if (
					variantOptions.length == options.length &&
					variantOptions.every((x) => options.includes(x))
				) {
					return variant;
				}
			});

			return variant;
		},

		selectedVariantBottom: function () {
			let variants = this.selectedBottom.product.variants;
			let options = [];

			for (const [key, value] of Object.entries(
				this.selectedBottom.selectedOptions
			)) {
				options.push(value);
			}

			let variant = variants.find((variant) => {
				let variantOptions = variant.title.split(" / ");
				if (
					variantOptions.length == options.length &&
					variantOptions.every((x) => options.includes(x))
				) {
					return variant;
				}
			});

			return variant;
		},

		// // Cozy Earth Site Wide Discount
		// sitewide_discount: function() {
		//   let discount = window.discount;
		//   let adjusted_discount = (100 - discount) / 100;

		//   return (this.selectedVariant.price * adjusted_discount)
		// },
	},

	watch: {
		// selectedVariant: function() {
		//   if(this.carousel && this.selectedVariant.featured_media !== undefined) {
		//     this.carousel.slideTo(this.productImages.map(x => x.id).indexOf(this.selectedVariant.featured_media.id));
		//   }
		//   if (window.history.replaceState) {
		//     let searchParams = new URLSearchParams(window.location.search);
		//     searchParams.set('variant', this.selectedVariant.id);
		//     let newPath = window.location.pathname + '?' + searchParams.toString() + window.location.hash;
		//     window.history.replaceState({ path: newPath }, '', newPath);
		//   }
		//   this.updateProductImages();
		// }
	},

	methods: {
		imageSize(src, size) {
			return src.replace(/\.jpg|\.png|\.gif|\.jpeg/g, function (match) {
				return "_" + size + match;
			});
		},

		// updateProductImages() {
		//   let colorOption = this.product.options.find(x => x.name == 'Color');
		//   let color, filteredImages;

		//   if(colorOption) {
		//     color = this.selectedVariant['option' + colorOption.position];
		//     filteredImages = this.product.media.filter(x => x.alt !== null && x.alt.toLowerCase().includes(color.toLowerCase()));
		//   }

		//   if(filteredImages && filteredImages.length > 0) {
		//     this.productImages = filteredImages;

		//     if(this.carousel) {
		//       this.carousel.slideTo(0, 0);
		//     }
		//   } else {
		//     this.productImages = this.product.media;
		//   }
		// },

		formatMoney(value) {
			return Shopify.formatMoney(value);
		},

		handleAddToCart(event) {
			CartJS.addItems([
				{
					id: this.selectedVariantTop.id,
					quantity: 1,
				},
				{
					id: this.selectedVariantBottom.id,
					quantity: 1,
				},
			]);

			//LiveConnectTag for advertisers
			window.liQ = window.liQ || [];
			window.liQ.push({
				event: "addToCart",
				...(window.customer.email && { email: window.customer.email }),
			});
			// End LiveConnectTag for advertisers

			window.dispatchEvent(new CustomEvent("ud-cart-open"));
		},

		fetchProduct(handle) {
			return new Promise((resolve, reject) => {
				fetch(`${window.origin}/products/${handle}.js`, {
					method: "GET",
				})
					.then((response) => response.json())
					.then((data) => {
						resolve(data);
					})
					.catch((error) => {
						reject(error);
					});
			});
		},
	},

	created() {
		// let searchParams = new URLSearchParams(window.location.search);
		// let selectedVariant = this.product.variants.find(x => x.id == searchParams.get('variant'));
		// if(selectedVariant !== undefined) {
		//   this.product.options.forEach((option, index) => {
		//     this.options[option.name] = selectedVariant.options[index];
		//   });
		// } else {
		//   this.product.options.forEach((option, index) => {
		//     this.options[option.name] = option.values[0];
		//   });
		// }
	},

	mounted() {
		Promise.all([
			this.fetchProduct("womens-bamboo-stretch-knit-collared-long-sleeve-button-down"),
			this.fetchProduct("womens-bamboo-stretch-knit-long-sleeve-polo"),
			this.fetchProduct("womens-bamboo-stretch-knit-short-sleeve-polo"),
			this.fetchProduct("womens-bamboo-stretch-knit-pant"),
			this.fetchProduct("womens-bamboo-stretch-knit-shorts"),
			this.fetchProduct("womens-bamboo-stretch-knit-tapered-pant"),
		]).then((products) => {
			this.products = products;

			this.top = {
				longCollarButton: {
					name: 'Long Sleeve Collared Button Down',
					product: products.find(
						(x) => x.handle == "womens-bamboo-stretch-knit-collared-long-sleeve-button-down"
					),
					selectedOptions: Object.fromEntries(
						products
							.find((x) => x.handle == "womens-bamboo-stretch-knit-collared-long-sleeve-button-down")
							.options.map((x) => [x.name, x.values[0]])
					),
				},

				longPolo: {
					name: 'Long Sleeve Polo',
					product: products.find(
						(x) => x.handle == "womens-bamboo-stretch-knit-long-sleeve-polo"
					),
					selectedOptions: Object.fromEntries(
						products
							.find((x) => x.handle == "womens-bamboo-stretch-knit-long-sleeve-polo")
							.options.map((x) => [x.name, x.values[0]])
					),
				},

				shortPolo: {
					name: 'Short Sleeve Polo',
					product: products.find(
						(x) => x.handle == "womens-bamboo-stretch-knit-short-sleeve-polo"
					),
					selectedOptions: Object.fromEntries(
						products
							.find((x) => x.handle == "womens-bamboo-stretch-knit-short-sleeve-polo")
							.options.map((x) => [x.name, x.values[0]])
					),
				},

				selectedLength: "longCollarButton",
			};

			this.bottom = {
					pant: {
						name: 'Pants',
						product: products.find((x) => x.handle == "womens-bamboo-stretch-knit-pant"),
						selectedOptions: Object.fromEntries(
							products
								.find((x) => x.handle == "womens-bamboo-stretch-knit-pant")
								.options.map((x) => [x.name, x.values[0]])
						),
					},

					short: {
						name: 'Shorts',
						product: products.find((x) => x.handle == "womens-bamboo-stretch-knit-shorts"),
						selectedOptions: Object.fromEntries(
							products
								.find((x) => x.handle == "womens-bamboo-stretch-knit-shorts")
								.options.map((x) => [x.name, x.values[0]])
						),
					},

					pantTapperd: {
						name: 'Tapered Pants',
						product: products.find((x) => x.handle == "womens-bamboo-stretch-knit-tapered-pant"),
						selectedOptions: Object.fromEntries(
							products
								.find((x) => x.handle == "womens-bamboo-stretch-knit-tapered-pant")
								.options.map((x) => [x.name, x.values[0]])
						),
					},

				selectedLength: "pant",
			};

			this.loading = false;

			this.$nextTick(() => {
				this.carousel = new Swiper(this.$refs.carousel, {
					grabCursor: true,

					pagination: {
						el: ".swiper-pagination",
					},

					a11y: {
						containerMessage: "Product Images",
						containerRoleDescriptionMessage: "carousel, use left and right arrow keys in focus mode to navigate slides",
						itemRoleDescriptionMessage: "slide",
					},

					spaceBetween: 10,
					observer: true,
					observeSlideChildren: true,
					observeParents: true,
				});

				attachSwiperArrowHandler(this.carousel);

				this.optionsCarousel = new Swiper(this.$refs.optionsCarousel, {
					grabCursor: true,

					spaceBetween: 10,
					observer: true,
					observeSlideChildren: true,
					observeParents: true,
					noSwiping: true,
					allowTouchMove: false,
					grabCursor: false,
					preventClicks: false,
					preventClicksPropagation: false,
				});

				yotpo.refreshWidgets();
			});
		});
	},
}).mount("#product");
